module.exports = __webpack_public_path__ + "img/weixingongzhonghao.d8159e28.jpg";